export default __webpack_public_path__ + "static/media/5.3ebbf927.jpg";